import { type Common } from './common.js';
import {
  type AgentConversationResponseTemplate,
  type AgentConversationResponseTemplateQuery,
  type CreateValues,
  type UpdateValues,
} from './models/agentConversationResponseTemplate.js';

interface SingleAgentConversationResponseTemplateResponse {
  agentConversationResponseTemplate: AgentConversationResponseTemplate;
}

interface MultipleAgentConversationResponseTemplateResponse {
  agentConversationResponseTemplates: AgentConversationResponseTemplate[];
}

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/agent-conversation-response-templates';
  }

  async getAgentConversationResponseTemplates(
    query: AgentConversationResponseTemplateQuery
  ): Promise<MultipleAgentConversationResponseTemplateResponse> {
    const url = this.common.constructPath(this.baseEndpoint, query);
    return await this.common.getJSON(url);
  }

  async createAgentConversationResponseTemplate(
    values: CreateValues
  ): Promise<SingleAgentConversationResponseTemplateResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}`);
    return await this.common.postJSON(url, values);
  }

  async updateAgentConversationResponseTemplate(
    agentConversationResponseTemplateId: string,
    values: Partial<UpdateValues>
  ): Promise<SingleAgentConversationResponseTemplateResponse> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${agentConversationResponseTemplateId}`
    );
    return await this.common.patchJSON(url, values);
  }

  async deleteAgentConversationResponseTemplate(
    agentConversationResponseTemplateId: string,
    shouldSoftDelete: boolean = true
  ): Promise<void> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${agentConversationResponseTemplateId}`,
      {
        softDelete: shouldSoftDelete,
      }
    );
    return await this.common.deleteJSON(url);
  }
}
